import { mapState } from 'vuex';
import { buildQueryString } from '@/utils/urlHelper';
import PageHeader from '@/components/widgets/PageHeader/PageHeader.vue';

// @vue/component
export default {
  name: 'Logout',
  components: {
    PageHeader,
  },
  data() {
    return {
      logoutMessage: 'You are now signed out. Have a great day!',
    };
  },
  created() {
    if (this.$route.query.message) this.logoutMessage = this.$route.query.message;
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.login.loggedIn,
      loginType: (state) => state.login.loginType,
      appInfo: (state) => state.login.appInfo,
      siteInfo: (state) => state.site.siteInfo,
      afterLoginURL: (state) => state.login.afterLoginURL,
      // eslint-disable-next-line
      title: (state) => state.site.siteInfo.displayOptions.showSiteNameOnLoginScreen ? state.site.siteInfo.name : 'Log in',
      inAppLogin: (state) => state.login.loginType === 'app',
    }),
    logoutMessageHTML() {
      return this.logoutMessage
        .replace(/>/g, '&gt;')
        .replace(/</g, '&lt;')
        .replace(/\\n/g, '<br>');
    },
  },
  methods: {
    onSubmitLogin() {
      let route = '/login';
      const query = {};

      if (this.$route.params.productCode) route += `/${this.$route.params.productCode}`;

      if (this.inAppLogin) {
        query.generic = true;
        query.redirect_uri = this.appInfo.redirect_uri;
        if (this.appInfo.state) query.state = this.appInfo.state;
        if (this.appInfo.client_id) query.client_id = this.appInfo.client_id;
        if (this.appInfo.scope) query.scope = this.appInfo.scope;
      }

      route += `?${buildQueryString(query)}`;

      if (this.siteInfo.sso.enabled && this.siteInfo.sso.loginStyle === 'SSO automatic-start') {
        window.location.href = `/launchpad/saml/start?SAMLAfterLoginURL=${encodeURIComponent(this.afterLoginURL)}`;
        return;
      }

      this.$router.push(route);
    },
  },
  watch: {
    loggedIn(loggedIn) {
      if (this.loginType === 'account' && loggedIn) this.onSubmitLogin();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/Logout/Logout.js